/* eslint-disable import/no-import-module-exports */
import { Plugins } from '@leverege/plugin';
import { ModelFactory } from '@leverege/ui-plugin';
import Util from "./Util.js";
import Attributes from "../Attributes.js";
export const I18nResolverFactory = Plugins.createFactory('AttributeI18nResolver', {
  pluginKey: 'resolver',
  strategy: Plugins.ALL
});

/** 
 * @param {object} value the value to resolve
 * @param {object} options the resolve options
 * @param {object} options.objectType the type the i18nResolver is applicable too
 * @param {object} options.attrName the attribute name
 * @param {object} options.i18nResolver the i18nResolver configs (e.g type) to use
 * @return {array} an array resolve objects (Strings or components). By default, 
 * an aray of value.toString() is returned if no i18nResolver exists for the options
 */
function resolve(value, options) {
  const resolver = options.i18nResolver == null ? null : I18nResolverFactory.get(options.i18nResolver.type);
  const i18nGetter = Attributes.getOption(options.attrName, options.objectType, 'i18nGetter');
  if (i18nGetter) {
    if (resolver) {
      return resolver.resolve(value, {
        i18nGetter
      });
    }
    if (Array.isArray(value)) {
      return value.map(element => {
        const strElement = element?.toString?.();
        return i18nGetter(strElement, strElement);
      });
    }
    const strValue = value?.toString?.();
    if (strValue) {
      const resolvedValue = i18nGetter(strValue, strValue);
      return [resolvedValue];
    }
  }
  return value == null || value?.length === 0 ? [] : Array.isArray(value) ? value : [value.toString()];
}
function createI18nResolverModel(type) {
  const ftype = Util.getI18nResolverTypeForType(type);
  const model = ModelFactory.get(ftype);
  if (model) {
    return model.create();
  }
  return null;
}
export default {
  resolve,
  getI18nResolverTypeForType: Util.getI18nResolverTypeForType,
  createI18nResolverModel
};